import { Resource as e } from "@coveo/platform-client";
//#region src/resources/HardwareMinimumsResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/indexautomation/hardware/minimums";
	}
	listAllHardwareMinimums() {
		return this.api.get(t.baseUrl);
	}
	listHardwareMinimums() {
		return this.api.get(this.buildPath(`${t.baseUrl}/${this.api.organizationId}`));
	}
};
//#endregion
export { t as HardwareMinimumsResource };

//# sourceMappingURL=HardwareMinimumsResource.js.map